import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "fas fa-cube p-mx-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entities, (entity, index) => {
    return (_openBlock(), _createBlock("div", {
      class: "expandable-entities",
      key: index
    }, [
      _createVNode("h4", {
        draggable: "true",
        onDragstart: ($event: any) => (_ctx.onDragStart($event, entity))
      }, [
        _withDirectives(_createVNode("i", _hoisted_1, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t(`qbe.entities.types.cube`),
            void 0,
            { top: true }
          ]
        ]),
        _createVNode("span", {
          class: "kn-flex",
          onClick: ($event: any) => (_ctx.expandEntity(entity))
        }, _toDisplayString(entity.name), 9, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "fas fa-edit",
          class: "p-button-text p-button-rounded p-button-plain p-ml-auto",
          onClick: ($event: any) => (_ctx.$emit('editSubquery', entity))
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "fas fa-trash",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: ($event: any) => (_ctx.$emit('deleteSubquery', index, entity))
        }, null, 8, ["onClick"]),
        (entity.expanded)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-chevron-up",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: ($event: any) => (entity.expanded = false)
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "pi pi-chevron-down",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: ($event: any) => (entity.expanded = true)
            }, null, 8, ["onClick"]))
      ], 40, ["onDragstart"]),
      _withDirectives(_createVNode("ul", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(entity.fields, (child, index) => {
          return (_openBlock(), _createBlock("li", {
            key: index,
            draggable: "true",
            onDragstart: ($event: any) => (_ctx.onDragStart($event, child))
          }, [
            _withDirectives(_createVNode("i", {
              class: [_ctx.getIconCls(child.iconCls), "p-mx-2"]
            }, null, 2), [
              [
                _directive_tooltip,
                _ctx.$t(`qbe.entities.types.${child.iconCls}`),
                void 0,
                { top: true }
              ]
            ]),
            _createVNode("span", null, _toDisplayString(child.alias), 1)
          ], 40, ["onDragstart"]))
        }), 128))
      ], 512), [
        [_vShow, entity.expanded]
      ])
    ]))
  }), 128))
}